import React from 'react'

import { Box, Display, JustifyContent, Link, LinkVariant } from '@gousto-internal/citrus-react'

import { getAppStoreUrl, getPlayStoreUrl } from 'components/AppStoreLinks/storeUrls'
import config from 'config/index'

import appStoreBadge from './assets/app-store-badge.svg'
import googlePlayBadge from './assets/google-play-badge.svg'

// Light 120×40 badges (the legacy black -bw badges vanish on the slate).
const GOOGLE_PLAY_URL = getPlayStoreUrl(config.apps.playStoreId)
const APP_STORE_URL = getAppStoreUrl(config.apps.appStoreId)

export const AppStoreBadges = () => (
  <Box display={Display.Flex} gap={2} justifyContent={JustifyContent.Center}>
    <Link href={GOOGLE_PLAY_URL} variant={LinkVariant.None} data-testid="footer-play-store">
      <img src={googlePlayBadge} alt="Get it on Google Play" width={120} height={40} />
    </Link>
    <Link href={APP_STORE_URL} variant={LinkVariant.None} data-testid="footer-app-store">
      <img src={appStoreBadge} alt="Download on the App Store" width={120} height={40} />
    </Link>
  </Box>
)
